/**
 * Central route map — single source of truth for all navigable paths.
 * Always use these constants rather than hard-coding path strings.
 */
export const ROUTES = {
  home:           '/',
  aiConsulting:   '/ai-consulting',
  automations:    '/automations',
  customers:      '/exempel',
  contact:        '/contact',
  klagobot:       '/klagobot',
  swishkassa:     '/swishkassa',
  threeDPrinting: '/3d-printing',
} as const;

/** Paths that have an /en/* equivalent. */
export const EN_SUPPORTED_PATHS = new Set<string>([
  ROUTES.home,
  ROUTES.aiConsulting,
  ROUTES.automations,
  ROUTES.customers,
  ROUTES.contact,
  ROUTES.klagobot,
  ROUTES.swishkassa,
  ROUTES.threeDPrinting,
]);

/**
 * Prefix a path with /en when lang is "en".
 * "/" becomes "/en" (not "/en/").
 */
export function withLang(path: string, lang: string): string {
  if (lang !== 'en') return path;
  if (path === '/') return '/en';
  return '/en' + path;
}

/**
 * Strip the /en prefix and return the base Swedish path.
 * "/en" → "/"
 * "/en/klagobot" → "/klagobot"
 * "/klagobot" → "/klagobot"  (no-op when already Swedish)
 */
export function stripLangPrefix(path: string): string {
  if (path === '/en' || path === '/en/') return '/';
  if (path.startsWith('/en/')) return path.slice(3);
  return path;
}
